export const REGIONS = {
  EMEA: 'EMEA',
  US: 'US',
} as const;

export type Regions = typeof REGIONS;
export type Region = Regions[keyof Regions];

export const ENVS = {
  QA: 'QA',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION',
} as const;

export type Envs = typeof ENVS;
export type Env = Envs[keyof Envs];

export const ENV_CONFIG_KEYS = {
  RFIS_URL: 'RFIS_URL',
  APIGEE_URL: 'APIGEE_URL',
} as const;

export type EnvConfigKeys = typeof ENV_CONFIG_KEYS;
export type EnvConfigKey = EnvConfigKeys[keyof EnvConfigKeys];

const RFIS_URL: Record<Env, string> = {
  [ENVS.QA]: '/bim360/rfis-qa/v2',
  [ENVS.STAGING]: '/bim360/rfis-stg/v2',
  [ENVS.PRODUCTION]: '/bim360/rfis/v2',
};

const APIGEE_URL: Record<Env, string> = {
  [ENVS.QA]: 'https://developer-stg.api.autodesk.com',
  [ENVS.STAGING]: 'https://developer-stg.api.autodesk.com',
  [ENVS.PRODUCTION]: 'https://developer.api.autodesk.com',
};

export type EnvConfig = Record<EnvConfigKey, string>;

const getEnvConfig = (env: Env): EnvConfig => ({
  [ENV_CONFIG_KEYS.RFIS_URL]: RFIS_URL[env],
  [ENV_CONFIG_KEYS.APIGEE_URL]: APIGEE_URL[env],
});

const getEmeaEnvConfig = getEnvConfig;

export type RegionConfig = Record<Env, EnvConfig>;

const US_CONFIG: RegionConfig = {
  [ENVS.QA]: getEnvConfig(ENVS.QA),
  [ENVS.STAGING]: getEnvConfig(ENVS.STAGING),
  [ENVS.PRODUCTION]: getEnvConfig(ENVS.PRODUCTION),
};

const EMEA_CONFIG: RegionConfig = {
  [ENVS.QA]: getEmeaEnvConfig(ENVS.QA),
  [ENVS.STAGING]: getEmeaEnvConfig(ENVS.STAGING),
  [ENVS.PRODUCTION]: getEmeaEnvConfig(ENVS.PRODUCTION),
};

export const ENV_CONFIGS: Record<Region, RegionConfig> = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: EMEA_CONFIG,
};

export enum HttpMethod {
  Get = 'GET',
  Post = 'POST',
  Delete = 'DELETE',
  Patch = 'PATCH',
  Put = 'PUT',
}

export const defaultHeaders = {
  'Content-Type': 'application/json',
};
